// extracted by mini-css-extract-plugin
export default {"wrap":"Us-z","fullWidth":"Vs-z","items":"Ws-z","featureCss":"Xs-z","disabled":"Ys-z","imgCss":"Zs-z"};